import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./index";
import { set } from "date-fns";

export enum AppRegionEnum {
  US = "US",
  CA = "CA",
}

interface AppConfigState {
  region: AppRegionEnum;
}

const initialState: AppConfigState = {
  region: AppRegionEnum.CA,
};

const appConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  reducers: {
    setAppConfig: (state, action: PayloadAction<Partial<AppConfigState>>) => {
      return { ...state, ...action.payload };
    },
    setRegion: (state, action: PayloadAction<AppRegionEnum>) => {
      state.region = action.payload;
    },
  },
});

export const { setAppConfig, setRegion } = appConfigSlice.actions;
export const selectAppConfig = (state: RootState) => state.appConfig;
export const selectAppRegion = (state: RootState) => state.appConfig.region;

export default appConfigSlice.reducer;
